

<template>
  <b-card class="m-0">

    <h5 v-if="canViewTitle">{{ title }}</h5>

    <FormAddLabAux
      v-if="canAddLabs"
      :examenesAuxiliares="examenesAuxiliares"
    />
    
    <CardEnvioLaboratorios
      :examenesAuxiliares="examenesAuxiliares"
      :onlyView="onlyView"
    />

    <EditarEnvioLabAux 
      :examenesAuxiliares="examenesAuxiliares"
    />

    <b-alert 
      v-if="!examenesAuxiliares.length && alertNoRegistros" 
      variant="danger" 
      show class="text-center col-12"
      style="padding: 40px; font-size: 20px;">
      <i class="fa-solid fa-triangle-exclamation" />
      No ha registrado ningun examen
    </b-alert>
  </b-card>

</template>

<script>
import { searchLabByName }     from '@/views/atencionCita/helpers/searchLabByName';
import EditarEnvioLabAux       from './EditarEnvioLabAux.vue';
import FormAddLabAux           from './FormAddLabAux.vue';
import  CardEnvioLaboratorios  from './CardEnvioLaboratorios.vue';
import { labAuxiliarService }  from '../../services';

export default {

  name: "DerivacionLaboratorioAux",

  components:{
    EditarEnvioLabAux,
    FormAddLabAux,
    CardEnvioLaboratorios
  },


  props:    {
    
    tokenAtencion:{
      type: String,
      default: null
    },

    esIess:{
      type:Boolean,
      default: false
    },

    maxEnvios: {
      type: Number,
      default: null 
    },

    alertNoRegistros: {
      type: Boolean,
      default: false
    },

    saveInState: {
      type: Function,
      default: null
    },

    title:{
      type: String,
      default: null
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },


  created() {
    this.loadData();
  },

  data() {
    return {

      searchLabByName,
      tempLabAuxiliar: null,
      homologado: false,
      examenesAuxiliares: [],
      justificacion: null,

      listaPrevia:[],

      showCardComplete: [],
      showFieldJustificacion: false,
    }
  },
  

  methods: {


    async loadData(){
      
      if(this.tokenAtencion){
        const responseLabs = await labAuxiliarService.getByAtencion(this.tokenAtencion);

        if (!responseLabs) return;

        this.examenesAuxiliares = responseLabs.map( lab => {
          const laboratorios = JSON.parse(lab.laboratorios);

          return {
            accion            : 'registrado',
            codigoOrden       : lab.codigoOrden,
            laboratorios      : laboratorios,
            justificacion     : lab.justificacion,
            idRegistro        : lab.id,
            estadoLaboratorio : lab.estadoLaboratorio 
          }
        });
      }
    
    },

  },


  computed:{

    canAddLabs(){
      if (this.onlyView) return false;
      return this.maxEnvios === null || this.examenesAuxiliares.length < this.maxEnvios;
    },


    canViewTitle() {
      if(this.onlyView && !this.examenesAuxiliares.length) return false;

      return true;
    }
  },


  watch:{
    examenesAuxiliares:{
      deep: true,
      handler(newValue){
        if(!this.saveInState) return;
        this.saveInState(newValue);
      }
    },


    tempLabAuxiliar() {
      this.homologado = false;
      this.justificacion = null;
      this.showFieldJustificacion = false;
    },


    tokenAtencion(newValue) {
      if(newValue) this.loadData();
    }
    
  }
}
</script>
